export type PrimaryWelcomeVariant = "control" | "available";

export interface ResolvePrimaryWelcomeVariantParams {
  /** Whether the user is a primary account owner (cap1Role === "PR"). */
  isPrimary: boolean;
  /** Whether the user onboarded via the EASE NEXT flow (excluded from the test). */
  isEaseOnboardingUser: boolean;
  /** Whether the corp-primary-welcome-modal-revamp experiment resolved to "available". */
  isRevampVariantAvailable: boolean;
}

/**
 * Resolves which variation of the PRIMARY welcome modal to render for the
 * CT1389T-171 Phase 0 A/B test.
 *
 * - Only primary users are eligible for the revamp ("available") variant
 *   — the non-primary modal has no "Set up my business" CTA to re-emphasize.
 * - EASE-onboarded users are excluded from the test and always see "control".
 * - Otherwise the LaunchDarkly flag decides (control vs available).
 */
export const resolvePrimaryWelcomeVariant = ({
  isPrimary,
  isEaseOnboardingUser,
  isRevampVariantAvailable,
}: ResolvePrimaryWelcomeVariantParams): PrimaryWelcomeVariant =>
  isPrimary && !isEaseOnboardingUser && isRevampVariantAvailable
    ? "available"
    : "control";
